'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_dom-helpers@3.3.1@dom-helpers/util/inDOM.js
// module id = 14
// module chunks = 0